<template>
  <div class="border-b border-slate-300">
    <div class="px-5 py-2 flex items-center justify-between">
      <div class="flex items-center gap-2">
        <div>
          <BlTextBody2 :text="period.start_time_string" />
          <BlTextBody2 text="-" />
          <BlTextBody2 :text="period.end_time_string" />
        </div>
        <div
          v-if="period.appointment.client && period.appointment.client.name"
          :title="period.appointment.client.name"
          class="truncate"
        >
          <BlTextSubtitle3
            :text="`${period.appointment.client.name}`"
            class="truncate"
          />
        </div>
      </div>
      <div class="flex items-center gap-2">
        <BlInputButton
          type="outlined"
          label="Reschedule"
          dense
          @clicked="rescheduleOpened = true"
        />
        <BlInputButton
          type="outlined"
          label="Cancel"
          dense
          @clicked="cancelOpened = true"
        />
      </div>
    </div>

    <RescheduleAppointmentOverlay
      v-if="rescheduleOpened && currentUser.role.includes('admin')"
      :appointmentId="period.appointment.id"
      @close-modal="rescheduleOpened = false"
      @after-commit="$emit('after-commit')"
    />
    <CancelAppointmentModal
      v-if="cancelOpened && currentUser.role.includes('admin')"
      :appointmentId="period.appointment.id"
      @close-modal="cancelOpened = false"
      @after-commit="$emit('after-commit')"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import RescheduleAppointmentOverlay from "../overlay/RescheduleAppointmentOverlay.vue";
import CancelAppointmentModal from "../modal/CancelAppointmentModal.vue";

import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "ResolveAppointment",
  components: {
    RescheduleAppointmentOverlay,
    CancelAppointmentModal,
    //
    BlTextSubtitle3,
    BlTextBody2,
    BlInputButton
  },
  props: {
    period: { type: Object, default: null }
    // @close-modal
    // @after-commit
  },
  data() {
    return {
      cancelOpened: false,
      rescheduleOpened: false
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  watch: {},
  async mounted() {},
  methods: {
    ...mapActions([""])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/appointments/overlapped/ResolveAppointment.vue